/**
 * 数値のみ入力用エディター
 */
<template>
<div class="input-edit-wrapper">
	<input 
		ref="inputEdit"
		class="input-edit"
		:class="r_input_class"
		:type="inputType"
		:disabled="r_disabled"
		:readonly="m_bReadOnly"
		:placeholder="r_placeholder"
		:pattern="pattern"
		:value="m_inputdata"
		:maxlength="r_max_length"
		:autocomplete="autocomplete"
		@input="updateValue(m_inputdata,$event)"
		@keyup="onKeyup" 
		@blur="onBlur"
		@focus="onFocus"
		@change="onChange"
	>
	<div v-if="r_text_footer !== ''" class="footer-text">
		{{r_text_footer}}
	</div>
	<input type="text" name="dummy" style="display:none;">
</div>
</template>
<script>
	export default {
		mixins: [
			require('js/common/inputEdit.mixin.vue'),
		],
	}
</script>



// WEBPACK FOOTER //
// resources/assets/js/parts_com/inputEdit.vue